import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const markWelcomeTextAsRead = async (callerId: string) => {
  const response = await mutationExecute({
    variables: {
      callerId,
    },
    mutation: graphql(`
      mutation MarkWelcomeTextAsRead($callerId: String!) {
        markWelcomeTextAsRead(callerId: $callerId)
      }
    `),
  });

  return response.data?.markWelcomeTextAsRead ?? false;
};
